import { BookingService } from './../../services/booking.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CurrencyPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'app-booked-service-card',
  templateUrl: './booked-service-card.component.html',
  styleUrls: ['./booked-service-card.component.scss'],
  providers: [CurrencyPipe]

})
export class BookedServiceCardComponent implements OnInit {

  @Input() services: any[] = [];
  @Input() bookedServices!: any;
  @Input() index!: number;
  @Output() deleteClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() saveClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() editClicked: EventEmitter<number> = new EventEmitter<number>();

  public formBooking!: FormGroup;
  public formService!: FormGroup;
  public serviceData!: any;
  public hours!: any;
  public formServiceEdit: boolean = false;
  public userSelectedService: any;
  public userSelectedProfile: any;

  public showModal = false;

  constructor(
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private bookingService: BookingService
  ) {}

  ngOnInit() {

    this.formService = this.formBuilder.group({
      service: [''],
      date: [''],
      hour: [''],
      units: [0],
      unit_price: [''],
      notes: [''],
      totalAmount: ['']
    })

    this.hours = ['10:00', '12:00'];

  }

  onChange(value: any) {
    this.userSelectedService = this.services[value.target.value];
  }

  onChangeProfile(value:any) {
    this.userSelectedProfile = this.userSelectedService.profiles[value.target.value];
  }

  calculateAmountService(){
    const units = this.formService.value.units || 0;
    const unitPrice = 50;
    const totalAmount = ( units * unitPrice);
    this.formService.patchValue({ totalAmount: totalAmount });
  }

  editService(index: number) {
    const bookedService = this.bookedServices[index];
    this.editClicked.emit(index);
    if (bookedService) {
      this.formService.patchValue({
        service: bookedService.service,
        date: bookedService.date,
        hour: bookedService.hour,
        units: bookedService.units,
        notes: bookedService.notes,
        unit_price: bookedService.unit_price,
        totalAmount: bookedService.totalAmount
      });
      setTimeout(() => {
        this.formServiceEdit = true;
      });
    } else {
      console.error('bookedService is undefined');
    }
  }

  deleteService() {
    this.deleteClicked.emit();
  }

  public formatDate(date: Date): string {
    return this.datePipe.transform(date, 'dd/MM/yyyy') || '';
  }

  saveService() {
    const editServiceData = this.formService.value;
    this.saveClicked.emit(editServiceData)
    this.formServiceEdit = false;
  }

}
